import React, { useState } from 'react';

import { useEscAction } from 'hooks/useEscAction';

import { InsertEmbededCodeModal } from '../../../../Iframe';
import { IMenuProps } from '../../types';
import { useScenePositioning } from '../ContentBlockDropdown/functions';
import sceneClassNames from '../index.module.css';

export const IframeContainer = ({ anchorRef, onAdd, onClose }: IMenuProps) => {
  useEscAction(onClose);

  const [selectedType, setSelectType] = useState('');

  const { sceneRef, sceneStyles } = useScenePositioning(anchorRef || { current: null });

  return (
    <div className={sceneClassNames.sceneWrapper} style={sceneStyles}>
      <div style={{ position: 'relative' }}>
        <div ref={sceneRef}>
          <InsertEmbededCodeModal
            selectedType={selectedType}
            setSelectType={setSelectType}
            onAdd={onAdd}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
};
